import { useCallback, useEffect, useRef, useState } from 'react';
import { ablyClient, authAbly } from './ably.provider';
import { axiosInstance } from '@refinedev/simple-rest';
import { API_URL } from 'utils/constants';

interface UseRealtimeDataProps {
    endpoint: string;
    channelName: string;
}

interface EndpointResponse {
    data: any[];
}

export function useRealtimeData({ endpoint, channelName }: UseRealtimeDataProps) {
    const [data, setData] = useState<EndpointResponse>({ data: [] });
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const channelRef = useRef<any>();

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axiosInstance.get<any[]>(`${API_URL}/${endpoint}`);
            setData(response);
        } catch (err: any) {
            setError(err.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    }, [endpoint]);

    useEffect(() => { 
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if (!ablyClient) authAbly();
        const channel = ablyClient!.channels.get(channelName);
        channelRef.current = channel;

        const handleMessage = (msg: any) => {
            setData({ data: msg.data });
        };

        channel.subscribe(handleMessage);

        return () => {
            channel.unsubscribe(handleMessage);
        };
    }, [channelName]);

    return { data, loading, error, refetch: fetchData };
}
